import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {UtilitiesService} from "../helpers/utilities.service";
import {Cv} from "../models/cv";
import {Observable, throwError} from "rxjs";
import {catchError, map} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class CvService {

  public CVs: Cv[] = [];

  headers = new HttpHeaders({
    'Content-Type': 'application/json'
  });

  constructor(private http: HttpClient,
              private utils: UtilitiesService) { }

  public async getAllCvs(): Promise<any> {
    return await this.http.get(this.utils.getCVApi(), {headers: this.headers}).toPromise();
  }

  public async sendCv(cv: Cv): Promise<any> {
    return await this.http.post(this.utils.getCVApi(), JSON.stringify(cv), {headers: this.headers}).toPromise();
  }

  public async getPDF(id: number): Promise<any>
  {
    return await this.http.post(this.utils.getCVApi('generate'), JSON.stringify(id), {headers: this.headers, responseType: 'blob'}).toPromise();
  }
}